/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable react/no-did-mount-set-state */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';
import TextareaAutosizeComponent from 'react-textarea-autosize';

const TextArea = (props) => (
  <textarea
    className={classnames('cmp-textarea', props.fontColor, props.className)}
    placeholder={props.placeholder ? props.intl.formatMessage({ id: props.placeholder }) : null}
    autoFocus={props.defaultFocus}
    onChange={props.onChange}
    onFocus={props.onFocus}
    value={props.value}
    maxLength={props.maxLength}
    style={{ height: props.height, ...props.style }}
  />
);
TextArea.propTypes = {
  className: PropTypes.string,
  intl: PropTypes.object,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  defaultFocus: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  fontColor: PropTypes.string,
  height: PropTypes.string,
  maxLength: PropTypes.number,
  style: PropTypes.object,
};
TextArea.defaultProps = {
  onChange: () => {},
};

const TextareaAutosize = injectIntl((props) => {
  return (
    <TextareaAutosizeComponent
      {...props}
      minRows={props.minRows}
      className={classnames('cmp-textarea', props.className)}
      placeholder={props.placeholder ? props.intl.formatMessage({ id: props.placeholder }) : null}
    />
  );
})

export {
  TextareaAutosize,
};

export default injectIntl(TextArea);
